import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { DashboardPage } from '../../components/dashboard/dashboard.page';
import { CustomerGuard } from '../../_guards/customer.guard';

const routes: Routes = [
  { path: ':option', component: DashboardPage, canActivate: [CustomerGuard] },
  { path: '', component: DashboardPage, canActivate: [CustomerGuard] },];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class DashboardRoutingModule { }
